import { z } from "zod";
import { toast } from "sonner";

import { BaseForm, FormInput } from "components/BaseForm";
import MachineApprovalStatusService from "services/MachineApprovalStatus";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
});

function MachineApprovalStatusForm({ model, onSuccess }) {
  const handleSubmit = async values => {
    const data = { name: values.name };
    if (model?.id) {
      await MachineApprovalStatusService.update(model.id, data);
    } else {
      await MachineApprovalStatusService.create(data);
    }
    toast.success("Machine Approval Status saved");
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{ name: model?.name ?? "" }}
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
    >
      <FormInput name="name" label="Name" required autoFocus />
    </BaseForm>
  );
}

export default MachineApprovalStatusForm;
